// ContextProviders.jsx

import React from "react";
import { UserRoleProvider } from "../components/Authentication/firebaseAuth/UserRoleContext";
import { LogoutProvider } from "../Layouts/Header/LogoutContext";
import { AccountProvider } from "../components/Account/AccountContext";
import { BrandProvider } from "../components/Brand/BrandContext";
import { SiteProvider } from "../components/Site/SiteContext";
import { ApprovalProvider } from "../components/CreativeApproval/ApprovalContext";
import { ReportModuleProvider } from "../components/Reports/ReportModuleContext";
import { PartnerProvider } from "../components/Partner/PartnerContext";
import { CampaignModuleProvider } from "../components/Campaign/CampaignModuleContext";
import { SiteApprovalProvider } from "../components/SiteApproval/SiteApprovalContext";
import { PreviewImage } from "../components/Creatives/CreateContext/CreativePreviewImageContext";
import { DashboardProvider } from "../components/Dashboard/DashboardContext";
import { CreativeContextValues } from "../components/Creatives/CreateContext/CreativeContextValues";
import { OceanProvider } from "../components/OceanOnBoarding/OceanOnBoardingContext";
import { FaqProvider } from "../components/FAQS/FaqContext";
import { TemplateModuleProvider } from "../components/Templates/TemplateContext";
import { ManageUserProvider } from "../components/ManageUser/ManageUserContext";

const AppProviders = ({ children }) => (
  <UserRoleProvider>
    <LogoutProvider>
      <AccountProvider>
        <BrandProvider>
          <SiteProvider>
            <SiteApprovalProvider>
              <ApprovalProvider>
                <ReportModuleProvider>
                  <PartnerProvider>
                    <DashboardProvider>
                      <CampaignModuleProvider>
                        <PreviewImage>
                          <CreativeContextValues>
                            <OceanProvider>
                              <TemplateModuleProvider>
                                <ManageUserProvider>
                                <FaqProvider>{children}</FaqProvider>
                                </ManageUserProvider>
                              </TemplateModuleProvider>
                            </OceanProvider>
                          </CreativeContextValues>
                        </PreviewImage>
                      </CampaignModuleProvider>
                    </DashboardProvider>
                  </PartnerProvider>
                </ReportModuleProvider>
              </ApprovalProvider>
            </SiteApprovalProvider>
          </SiteProvider>
        </BrandProvider>
      </AccountProvider>
    </LogoutProvider>
  </UserRoleProvider>
);

export default AppProviders;
